module.exports = __webpack_public_path__ + "img/br.5ade8392.png";